/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Setup_Display_Name_HintInputs */

const en_setup_display_name_hint = /** @type {(inputs: Setup_Display_Name_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visible to members of your household`)
};

const de_setup_display_name_hint = /** @type {(inputs: Setup_Display_Name_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sichtbar für Mitglieder deines Haushalts`)
};

/**
* | output |
* | --- |
* | "Visible to members of your household" |
*
* @param {Setup_Display_Name_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const setup_display_name_hint = /** @type {((inputs?: Setup_Display_Name_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Setup_Display_Name_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_setup_display_name_hint(inputs)
	return en_setup_display_name_hint(inputs)
});